module.exports = __webpack_public_path__ + "fonts/Lato-Semibold.8b4f872.woff2";